 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en":"lang-en","lang-en-old":"lang-en-old","lang-jp":"lang-jp"}[chunkId]||chunkId) + "." + {"chunk-01afcc4b":"91a77e65","chunk-0611f30a":"fb06dd08","chunk-b1bac830":"5b1fed50","chunk-1277a7a7":"09fff428","chunk-d180d67c":"adfafe43","chunk-081f1ef4":"530adac9","chunk-0caa0b94":"1cd37c80","chunk-0daab13c":"893ae0d0","chunk-0f2d6c82":"e056f374","chunk-18d2ef6e":"fa27356a","chunk-18fe17d5":"588d99ca","chunk-1b4a018c":"ed10c20f","chunk-1c1d7279":"f1bcb448","chunk-245436c4":"004072df","chunk-261bf2b1":"b4b3e66b","chunk-276eb667":"e9db750c","chunk-294c5100":"ea7acf6e","chunk-1f32f928":"bebaa525","chunk-e3c8c494":"3f7e6150","chunk-29944e12":"10a1a362","chunk-2facfa0c":"7259261f","chunk-36764d04":"4ff516e8","chunk-3e46ef46":"2f26aeef","chunk-4028b0c1":"1ea52217","chunk-4426838f":"edb77e3e","chunk-1947af5c":"408a1971","chunk-1b15670f":"e5c585cb","chunk-1e80b244":"39ee2665","chunk-340cd824":"15916deb","chunk-4476cd8e":"68001304","chunk-47ff8e3f":"9c32a486","chunk-4d3254da":"b2c80c38","chunk-56d872cc":"e93bcb52","chunk-68f54a3a":"439b55dc","chunk-ebb37a0a":"19ccae4b","chunk-446d2048":"796eedf4","chunk-4ee914f0":"eb5edfc2","chunk-5d580360":"da166d36","chunk-610e69d6":"d33af0b3","chunk-41b3f57c":"32e0e16e","chunk-54ff646f":"21d86b22","chunk-c0cd9eda":"f7c37152","chunk-be569626":"32f5889a","chunk-33b48bee":"710b01ae","chunk-9be89244":"91da524d","chunk-6a85dc5e":"230797bb","chunk-f546bad4":"5dbb1613","chunk-5c17edfc":"4d2b3470","chunk-ed0768e6":"fe5942ba","chunk-1072998a":"d832dfb2","chunk-5d7fafd6":"f6cff68a","chunk-66ea3950":"26d42962","chunk-6767c19f":"6d8a807d","chunk-6b3c6900":"94217350","chunk-6c8c6f2f":"a2f16860","chunk-6dd48750":"607b591d","chunk-716617e8":"24eb8020","chunk-2d0cc057":"bea733bb","chunk-379f6002":"abd3f691","chunk-5d6da804":"5ddd39d6","chunk-a2a825e4":"1bef1bfd","chunk-ce939870":"d993c2ce","chunk-e45ce9e0":"cd8f68db","chunk-72b8c82e":"3f84b332","chunk-75b87462":"a8d5a04a","chunk-77b44b06":"66fa061f","chunk-77d1912b":"1ed65d10","chunk-785fff7e":"9dabcacc","chunk-7cff695c":"634ca855","chunk-7d38b02d":"c7de0401","chunk-7f1f7146":"0b557c3a","chunk-2c7f698a":"339be587","chunk-3751fe1a":"e68eb5c2","chunk-8a858766":"c956a7fb","chunk-975722b0":"ccb20a4b","chunk-98136aa6":"3c91f722","chunk-5a8dc864":"0aaa11e0","chunk-4366cfed":"80a640da","chunk-ae336858":"afc1b021","chunk-efcf8886":"127b8951","chunk-7f5e67b7":"c3f485e5","chunk-a7d637a8":"4051f7ff","chunk-ac15eabe":"4d30a5a6","chunk-1a95efe9":"2fcbc42e","chunk-665ddf5c":"cc084bee","chunk-b94cd016":"f9a87d2d","chunk-bd4b0aa0":"f2fac9db","chunk-bfa99110":"3270ec80","chunk-c2f39d14":"4ffeabd2","chunk-c50e01cc":"6ea7b012","chunk-e226ee3a":"222a7949","chunk-7dc52953":"4efcbf7c","chunk-eddac93e":"bed350de","chunk-f36bbc70":"a91ee8b7","lang-en":"d03edc18","lang-en-old":"2934454c","lang-jp":"b43faca1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01afcc4b":1,"chunk-1277a7a7":1,"chunk-d180d67c":1,"chunk-081f1ef4":1,"chunk-0caa0b94":1,"chunk-0daab13c":1,"chunk-0f2d6c82":1,"chunk-18d2ef6e":1,"chunk-18fe17d5":1,"chunk-1b4a018c":1,"chunk-1c1d7279":1,"chunk-245436c4":1,"chunk-261bf2b1":1,"chunk-276eb667":1,"chunk-294c5100":1,"chunk-1f32f928":1,"chunk-e3c8c494":1,"chunk-29944e12":1,"chunk-2facfa0c":1,"chunk-36764d04":1,"chunk-3e46ef46":1,"chunk-4028b0c1":1,"chunk-4426838f":1,"chunk-1947af5c":1,"chunk-1b15670f":1,"chunk-1e80b244":1,"chunk-340cd824":1,"chunk-4476cd8e":1,"chunk-47ff8e3f":1,"chunk-4d3254da":1,"chunk-56d872cc":1,"chunk-68f54a3a":1,"chunk-ebb37a0a":1,"chunk-446d2048":1,"chunk-5d580360":1,"chunk-610e69d6":1,"chunk-41b3f57c":1,"chunk-54ff646f":1,"chunk-c0cd9eda":1,"chunk-be569626":1,"chunk-33b48bee":1,"chunk-6a85dc5e":1,"chunk-f546bad4":1,"chunk-5c17edfc":1,"chunk-1072998a":1,"chunk-5d7fafd6":1,"chunk-66ea3950":1,"chunk-6767c19f":1,"chunk-6b3c6900":1,"chunk-6c8c6f2f":1,"chunk-6dd48750":1,"chunk-379f6002":1,"chunk-5d6da804":1,"chunk-a2a825e4":1,"chunk-ce939870":1,"chunk-e45ce9e0":1,"chunk-72b8c82e":1,"chunk-75b87462":1,"chunk-77b44b06":1,"chunk-77d1912b":1,"chunk-785fff7e":1,"chunk-7cff695c":1,"chunk-7d38b02d":1,"chunk-7f1f7146":1,"chunk-2c7f698a":1,"chunk-3751fe1a":1,"chunk-8a858766":1,"chunk-975722b0":1,"chunk-5a8dc864":1,"chunk-4366cfed":1,"chunk-ae336858":1,"chunk-efcf8886":1,"chunk-7f5e67b7":1,"chunk-a7d637a8":1,"chunk-ac15eabe":1,"chunk-1a95efe9":1,"chunk-665ddf5c":1,"chunk-b94cd016":1,"chunk-bd4b0aa0":1,"chunk-bfa99110":1,"chunk-c2f39d14":1,"chunk-c50e01cc":1,"chunk-e226ee3a":1,"chunk-7dc52953":1,"chunk-eddac93e":1,"chunk-f36bbc70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en":"lang-en","lang-en-old":"lang-en-old","lang-jp":"lang-jp"}[chunkId]||chunkId) + "." + {"chunk-01afcc4b":"9311a5ef","chunk-0611f30a":"31d6cfe0","chunk-b1bac830":"31d6cfe0","chunk-1277a7a7":"61aa77ca","chunk-d180d67c":"61aa77ca","chunk-081f1ef4":"7846ce4e","chunk-0caa0b94":"edf6c75c","chunk-0daab13c":"a96312a1","chunk-0f2d6c82":"666146c8","chunk-18d2ef6e":"01da28bb","chunk-18fe17d5":"23aaf406","chunk-1b4a018c":"a86c74d1","chunk-1c1d7279":"47c184c0","chunk-245436c4":"46dc9c3e","chunk-261bf2b1":"bf2ced3c","chunk-276eb667":"95f5a9ae","chunk-294c5100":"067be1f2","chunk-1f32f928":"f399bc1b","chunk-e3c8c494":"217f2739","chunk-29944e12":"5701902c","chunk-2facfa0c":"eae8e5f8","chunk-36764d04":"5759a54c","chunk-3e46ef46":"64c2694b","chunk-4028b0c1":"8119bc12","chunk-4426838f":"baee7b0b","chunk-1947af5c":"f213bfb5","chunk-1b15670f":"fa4ee144","chunk-1e80b244":"08bb45d0","chunk-340cd824":"eff7d3c8","chunk-4476cd8e":"1fc17f0b","chunk-47ff8e3f":"007e3a2a","chunk-4d3254da":"a8e101fa","chunk-56d872cc":"9525475d","chunk-68f54a3a":"e77d3769","chunk-ebb37a0a":"57ad5dfc","chunk-446d2048":"40a5043a","chunk-4ee914f0":"31d6cfe0","chunk-5d580360":"bc5b00bf","chunk-610e69d6":"65b1b702","chunk-41b3f57c":"4da61f0e","chunk-54ff646f":"fb4fad7b","chunk-c0cd9eda":"96e005ca","chunk-be569626":"944de8ee","chunk-33b48bee":"2feeb1db","chunk-9be89244":"31d6cfe0","chunk-6a85dc5e":"65af495e","chunk-f546bad4":"a524dfc0","chunk-5c17edfc":"6cab533a","chunk-ed0768e6":"31d6cfe0","chunk-1072998a":"387358d1","chunk-5d7fafd6":"ba1c68d1","chunk-66ea3950":"ea4eba91","chunk-6767c19f":"9cda1692","chunk-6b3c6900":"335edda8","chunk-6c8c6f2f":"b537552e","chunk-6dd48750":"08417e41","chunk-716617e8":"31d6cfe0","chunk-2d0cc057":"31d6cfe0","chunk-379f6002":"704644dc","chunk-5d6da804":"8b44d940","chunk-a2a825e4":"678273e5","chunk-ce939870":"8b44d940","chunk-e45ce9e0":"6ac45f4a","chunk-72b8c82e":"00433555","chunk-75b87462":"ee8919a8","chunk-77b44b06":"900708ce","chunk-77d1912b":"fb78244b","chunk-785fff7e":"5d11d55d","chunk-7cff695c":"7c96be16","chunk-7d38b02d":"aa5abc0e","chunk-7f1f7146":"d5a29275","chunk-2c7f698a":"20caa69b","chunk-3751fe1a":"44011fa3","chunk-8a858766":"d2c56506","chunk-975722b0":"e01edb21","chunk-98136aa6":"31d6cfe0","chunk-5a8dc864":"88ca282b","chunk-4366cfed":"9b5e9401","chunk-ae336858":"76166dc4","chunk-efcf8886":"df311dc0","chunk-7f5e67b7":"f8edd16c","chunk-a7d637a8":"f373c105","chunk-ac15eabe":"4b1dca54","chunk-1a95efe9":"afc31612","chunk-665ddf5c":"627df84e","chunk-b94cd016":"18593d05","chunk-bd4b0aa0":"828a3120","chunk-bfa99110":"81d2959d","chunk-c2f39d14":"bba9eab8","chunk-c50e01cc":"4bf8a27f","chunk-e226ee3a":"e88dffd8","chunk-7dc52953":"d5587c49","chunk-eddac93e":"208192f0","chunk-f36bbc70":"af0e103a","lang-en":"31d6cfe0","lang-en-old":"31d6cfe0","lang-jp":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
